<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Manage Users</h4>
    </div>
    <div class="col-sm-3">
        <div class="btn-group float-sm-right">
            <button type="button" (click)="ClearForm()" data-toggle="modal" data-target="#user_modal" class="btn btn-outline add_btn btn-sm">
                <i class="zmdi zmdi-plus mr-1"></i>Add User
            </button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <!-- <h5 class="card-title">Responsive Table</h5> -->
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-bordered table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Full Name</th>
                                <th>Mobile No.</th>
                                <th>Email</th>
                                <th style="white-space: normal;">Address</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr *ngFor="let user of rowData; let i = index">
                                <td>{{i+1}}</td>
                                <td>{{user.firstName}} {{user.lastName}}</td>
                                <td>{{user.mobileNo}}</td>
                                <td>{{user.email}}</td>
                                <td style="white-space: normal;">{{user.address}}</td>
                                <td style="text-align: center;">
                                    <a data-toggle="modal" data-target="#user_modal" (click)="EditUser(user)" style="color: dodgerblue">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a><span style="margin-left: 15px;"></span>
                                    <a (click)="DeleteUser(user.userId)" style="color: red;">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-wrapper" id="loading" *ngIf="isLoading" >
    <div class="loader-card">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="spinner-ring delay"></div>
            <div class="core"></div>
        </div>
    </div>
</div>
<div id="user_modal" class="modal fade hide" role="dialog">
    <form action="#" #masterUserForm="ngForm">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title">User Details</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <input type="hidden" id="userId" name="userId">
                        <div class="form-group col-md-6">
                            <label for="firstName">First Name</label>
                            <input type="text" id="firstName" name="firstName" class="form-control form-control-sm"
                                [(ngModel)]="userForm.firstName" required #firstName="ngModel">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastName">Last Name</label>
                            <input type="text" id="lastName" name="lastName" class="form-control form-control-sm"
                                [(ngModel)]="userForm.lastName" required #lastName="ngModel">
                        </div>
            
                        <div class="form-group  col-md-6">
                            <label for="email">Email</label>
                            <input type="text" id="email" name="email" class="form-control form-control-sm"
                                [(ngModel)]="userForm.email" required #email="ngModel">
                        </div>
            
                        <div class="form-group col-md-6">
                            <label for="mobileNo">Mobile No.</label>
                            <input type="text" id="mobileNo" name="mobileNo" class="form-control form-control-sm"
                                [(ngModel)]="userForm.mobileNo" required #mobileNo="ngModel">
                        </div>

                        <div class="form-group col-md-12">
                            <label for="address">Address</label>
                            <input type="text" id="address" name="address" class="form-control form-control-sm"
                                [(ngModel)]="userForm.address" required #address="ngModel">
                        </div>
                        
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="reset" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()">
                        {{ isEditMode ? 'Update' : 'Save' }}</button>
                </div>
            </div>
        </div>
    </form>
</div>
